export class MunicipioVariacion {
    [key: string]: string | number | undefined
    public id: number | undefined;
    public variacion: string | undefined;
    public municipio: string | undefined;
}